export const industryMatchModes = ["REQUIRED", "PREFERENCE", "EXPLORATORY"];
export const canonicalIndustries = ["ENERGY", "TECHNOLOGY", "TELECOMMUNICATIONS", "SECURITY", "INFRASTRUCTURE", "PROFESSIONAL_SERVICES", "LOGISTICS", "RETAIL", "FINANCIAL_SERVICES", "GOVERNMENT", "MINING", "AGRICULTURE", "UNKNOWN"];
const terms = {
    ENERGY: ["energia", "energy", "utilities", "utility", "gas utilities", "oil gas", "oil and gas", "petroleo", "gas natural", "electric power", "renewables", "solar"],
    TECHNOLOGY: ["tecnologia", "technology", "software", "information technology", "it services", "saas", "cloud", "computer software"],
    TELECOMMUNICATIONS: ["telecomunicaciones", "telecommunications", "telecom", "internet service provider", "isp", "connectivity"],
    SECURITY: ["seguridad", "security", "electronic security", "video surveillance", "cctv"],
    INFRASTRUCTURE: ["infraestructura", "infrastructure", "datacenter", "data center", "network infrastructure"],
    PROFESSIONAL_SERVICES: ["servicios", "services", "consulting", "professional services", "business services", "outsourcing"],
    LOGISTICS: ["logistica", "logistics", "transportation", "supply chain"],
    RETAIL: ["retail", "ecommerce", "e commerce", "marketplace"],
    FINANCIAL_SERVICES: ["bancos", "banking", "financial services", "fintech", "insurance"],
    GOVERNMENT: ["gobierno", "government", "public administration", "municipality", "municipalidad"],
    MINING: ["mineria", "mining"],
    AGRICULTURE: ["agro", "agriculture", "farming", "agribusiness"],
};
export function normalizeIndustryText(value) {
    return value.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ").trim();
}
function containsTerm(value, term) {
    const normalizedTerm = normalizeIndustryText(term);
    if (` ${value} `.includes(` ${normalizedTerm} `))
        return true;
    const stemToken = (token) => {
        if (token.length <= 4)
            return token;
        if (token.endsWith("ies") && token.length > 5)
            return `${token.slice(0, -3)}y`;
        if (/(?:ses|xes|zes|ches|shes)$/.test(token) && token.length > 5)
            return token.slice(0, -2);
        if (token.endsWith("s") && !token.endsWith("ss") && token.length > 4)
            return token.slice(0, -1);
        return token;
    };
    const valueTokens = value.split(" ").map(stemToken);
    const termTokens = normalizedTerm.split(" ").map(stemToken);
    return valueTokens.some((_, index) => termTokens.every((token, offset) => valueTokens[index + offset] === token));
}
export function canonicalizeIndustry(value) {
    const normalized = normalizeIndustryText(value);
    if (!normalized || ["unknown", "n a", "sin clasificar", "not available"].includes(normalized))
        return { canonical: "UNKNOWN", confidence: 0 };
    const matches = Object.entries(terms).flatMap(([canonical, values]) => values.filter((term) => containsTerm(normalized, term)).map((matchedTerm) => ({ canonical: canonical, matchedTerm, length: normalizeIndustryText(matchedTerm).length })));
    const best = matches.sort((left, right) => right.length - left.length)[0];
    return best ? { canonical: best.canonical, confidence: best.length === normalized.length ? 1 : 0.9, matchedTerm: best.matchedTerm } : { canonical: "UNKNOWN", confidence: 0.2 };
}
export function industryMatchesTargets(providerIndustry, targets) {
    const company = canonicalizeIndustry(providerIndustry);
    const targetCanonical = new Set(targets.map(canonicalizeIndustry).filter((item) => item.canonical !== "UNKNOWN").map((item) => item.canonical));
    return { company, matches: company.canonical !== "UNKNOWN" && targetCanonical.has(company.canonical), targets: [...targetCanonical] };
}
